const replaceMap = {
  "Si": "I",
  "H`": "1",
  "b\\\\w": "4",
  "z|": ">",
  "/'": "?",
  '"': "¿",
  'Tt': "Q",
  "b\\\\lj": "lå",
  "b\\\\\\j": "å",
  "0f\\": "0",
  "`\\": "~",
  "!":"Û"
};

const dict = {
 "अ": "c",
   "!":"Û",
      "आ": "cf",
      "ा": "f",
      "इ": "O",
      "ई": "O{",
      "र्": "{",
      "उ": "p",
      "ए": "P",
      "े": "]",
      "ै": "}",
      "ो": "f]",
      "ौ": "f}",
      "ओ": "cf]",
      "औ": "cf}",
      "ं": "+",
      "ँ": "F",
      "ि": "l",
      "ी": "L",
      "ु": "'",
      "ू": '"',
      "क": "s",
      "ख": "v",
      "ग": "u",
      "घ": "3",
      "ङ": "ª",
      "च": "r",
      "छ": "5",
      "ज": "h",
      "झ": "´",
      "ञ": "`",
      "ट": "6",
      "ठ": "7",
      "ड": "8",
      "ढ": "9",
      "ण": "0f",
      "त": "t",
      "थ": "y",
      "द": "b",
      "ध": "w",
      "न": "g",
      "प": "k",
      "फ": "km",
      "ब": "a",
      "भ": "e",
      "म": "d",
      "य": "o",
      "र": "/",
      "रू": "?",
      "ृ": "[",
      "ल": "n",
      "व": "j",
      "स": ";",
      "श": "z",
      "ष": "if",
      "ज्ञ": "1",
      "ह": "x",
      "१": "!",
      "२": "@",
      "३": "#",
      "४": "$",
      "५": "%",
      "६": "^",
      "७": "&",
      "८": "*",
      "९": "(",
      "०": ")",
      "।": ".",
      "्": "\\",
      "ऊ": "pm",
      "-": " ",
      "(": "-",
      ")": "_"
};

const formatUnicode=(unicodeText)=> {
    
  let index = -1;
  let normalized = "";
  while (index < unicodeText.length - 1) {
    index += 1;
   let character = unicodeText[index];
    try {
      try {
        if (character != "र") {
          if (
            unicodeText[index + 1] == "्" &&
            unicodeText[index + 2] != " " &&
            unicodeText[index + 2] != "।" &&
            unicodeText[index + 2] != ","
          ) {
            if (unicodeText[index + 2] !== "र") {
              if ("wertyuxasdghjkzvn".includes(dict[index])) {
                normalized += String.fromCharCode(parseInt(dict[index]) - 32);
                index++;
                continue;
              } else if (character == "स") {
                normalized += ":";
                index += 1;
                continue;
              } else if (character == "ष") {
                normalized += "i";
                index += 1;
                continue;
              }
            }
          }
        }
        if (
          unicodeText[index - 1] != "र" &&
          character == "्" &&
          unicodeText[index + 1] == "र"
        ) {
          if (
            unicodeText[index - 1] != "ट" &&
            unicodeText[index - 1] != "ठ" &&
            unicodeText[index - 1] != "ड"
          ) {
            normalized += "|";
            index += 1;
            continue;
          } else {
            normalized += "«";
            index += 1;
            continue;
          }
        }
      } catch (ex) {
        console.log("CATCHED 1");
      }
      normalized += character;
    } catch (ex) {
      console.log("CATCHED 2");
      normalized += character;
    }
  }
  normalized = normalized.replace("त|", "q");
  return normalized;
}

export const unicodeToPreeti = (text) => {
 let normalizedUnicode = formatUnicode(text);
 let converted = "";
 let index = -1;

  while (index < normalizedUnicode.length - 1) {
    index += 1;
    let character = normalizedUnicode[index];
    if (character == "\ufeff") continue;

    try {
      try {
        if (normalizedUnicode[index + 1] == "ि") {
          if (character == "q") converted += "l" + character;
          else converted += "l" + dict[character];
          index += 1;
          continue;
        }
        if (normalizedUnicode[index + 2] == "ि") {
          if (("WERTYUXASDGHJK:ZVN").includes(character)) {
            if (normalizedUnicode[index + 1] != "q") {
              converted +=
                "l" +
                character +
                dict[normalizedUnicode[index + 1]];
              index += 2;
              continue;
            } else if (normalizedUnicode[index + 1] == "q") {
              converted += "l" + character + normalizedUnicode[index + 1];
              index += 2;
              continue;
            }
          }
        }

        if (normalizedUnicode[index + 1] == "्" && character == "र") {
          if (
            normalizedUnicode[index + 3] == "ा" ||
            normalizedUnicode[index + 3] == "ो" ||
            normalizedUnicode[index + 3] == "ौ" ||
            normalizedUnicode[index + 3] == "े" ||
            normalizedUnicode[index + 3] == "ै" ||
            normalizedUnicode[index + 3] == "ी"
          ) {
            converted +=
              dict[normalizedUnicode[index + 2]] +
              dict[normalizedUnicode[index + 3]] +
              "{";
            index += 3;
            continue;
          } else if (normalizedUnicode[index + 3] == "ि") {
            converted +=
              dict[normalizedUnicode[index + 3]] +
              dict[normalizedUnicode[index + 2]] +
              "{";
            index += 3;
            continue;
          }
          converted +=
            dict[normalizedUnicode[index + 2]] + "{";
          index += 2;
          continue;
        }
        if (normalizedUnicode[index + 3] == "ि") {
          if (
            normalizedUnicode[index + 2] == "|" ||
            normalizedUnicode[index + 2] == "«"
          ) {
            if ("WERTYUXASDGHJK:ZVNIi".includes(character)) {
              converted +=
                "l" +
                character +
                dict[normalizedUnicode[index + 1]] +
                normalizedUnicode[index + 2];
              index += 3;
              continue;
            }
          }
        }
      } catch (ex) {
          print("Catched")
      }
      converted += dict[character] || character;
    } catch (ex) {
      converted += character;
    }
  }
  for (var key in replaceMap) {
    converted = converted.replace(key, replaceMap[key]);
  }
  
  converted = converted.replace(new RegExp("(.)[l][|]", "g"), "l$1|");
  converted = converted.replace(new RegExp("[k][l][m][|]", "g"), "lk|m");
  return converted;
};

// console.log(unicodeToPreeti("मेरो नाम लखन होइन रहेछ , कान्छु !"));
